import { render } from "./Button.vue?vue&type=template&id=014e90cc&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=014e90cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-014e90cc"

export default script